<template>
  <div class="bg-white">
    <Policy />
    <Documents />
    <div class="bge3ceff-opa rounded-t-5555">
      <DownloadApp />
      <Footer />
    </div>
  </div>
</template>
<script>
import Policy from "./components/regulation-policy.vue";
import Documents from "./components/policy-documents.vue";
import DownloadApp from "../home/components/DownloadApp.vue";
import Footer from "../Footer.vue";

export default {
  components: {
    Policy,
    Documents,
    DownloadApp,
    Footer,
  },
};
</script>
